<template>
  <div class="tw-mt-4" role="dialog">
    <label class="control-label">Etiqueta</label>
    <div class="dropdown dropup admin-form">
      <button
        @click="requestsTags"
        class="
          select
          tag-btn
          btn
          tw-w-full tw-flex tw-flex-wrap
          !tw-border !tw-border-gray-400 !tw-min-h-[40px]
          tw-border-solid
          !tw-h-[unset]
          tw-transition-all tw-gap-x-4 tw-gap-y-2 tw-pr-6
        "
        type="button"
        data-toggle="dropdown"
      >
        <span
          v-if="eventTags.length === 0"
          class="tw-font-normal tw-text-gray-600"
          >Selecionar</span
        >
        <div
          class="
            tw-border
            tw-border-gray-400
            tw-shadow
            tw-rounded-lg
            tw-flex
            tw-gap-2
            tw-items-center
            tw-px-2
            tw-py-1
            tw-truncate
          "
          v-for="eventTag in eventTags"
          :key="eventTag.id"
        >
          <input
            type="hidden"
            :name="`appointment[tag_ids][]`"
            :value="eventTag.id"
          />
          <div
            class="tw-h-4 tw-w-4 tw-rounded-full tw-flex-shrink-0"
            :style="{ backgroundColor: eventTag.color }"
          ></div>
          <span class="tw-font-semibold tw-text-sm tw-truncate"> {{ eventTag.name }} </span>
          <button
            @click="removeActiveTag(eventTag.id)"
            class="tw-font-normal -tw-text-gray-500"
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="tw-w-4 tw-h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <ul
          v-if="eventTags.length > 0"
          class="tw-flex tw-gap-4 tw-items-center tw-my-2.5 tw-flex-wrap"
        ></ul>

        <i class="arrow"></i>
      </button>

      <div class="dropdown-menu tw-mt-0 tw-ml-0 tw-py-0 tw-w-full tw-bg-white">
        <div v-if="isLoading" class="tw-text-center tw-py-4 tw-text-base">
          Carregando...
        </div>
        <div v-else>
          <ul
            v-if="tags"
            class="tw-flex tw-flex-col tw-max-h-[400px] tw-overflow-y-auto"
          >
            <li
              v-for="tag in tags"
              :key="tag.id"
              :class="[
                tag.selected ? 'tw-bg-gray-100' : '',
                'tw-group tw-px-4 tw-flex tw-items-center',
              ]"
            >
              <button
                type="button"
                @click="
                  tag.selected
                    ? removeActiveTag(tag.id, $event)
                    : setActiveTag($event, tag)
                "
                class="tw-flex-1 tw-py-3 tw-flex tw-items-center tw-truncate"
              >
                <label
                  class="tw-rounded-full tw-flex-shrink-0 tw-h-5 tw-w-5 tw-mb tw-mr-2"
                  :style="{ backgroundColor: tag.color }"
                ></label>
                <span class="tw-truncate">{{ tag.name }}</span>
              </button>
              <div
                class="tw-hidden group-hover:tw-flex tw-justify-end tw-gap-1"
              >
                <button
                  type="button"
                  v-if="tag.can_edit"
                  @click="showFormEditTag(tag)"
                  v-tooltip="tooltips.edit"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="tw-w-4 tw-h-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                    />
                  </svg>
                </button>
                <button
                  @click="removeTag(tag)"
                  type="button"
                  v-if="tag.can_destroy"
                  class="tw-ml-2"
                  v-tooltip="'Excluir'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="tw-w-4 tw-h-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                    />
                  </svg>
                </button>
              </div>
            </li>
          </ul>
          <ul v-else class="tw-text-center">
            <li>Nenhuma etiqueta.</li>
          </ul>
          <hr />
          <button
            :disabled="isLoading"
            @click="showFormTag"
            type="button"
            class="
              tw-py-2.5
              tw-mx-auto
              tw-font-bold
              tw-w-full
              tw-uppercase
              tw-text-center
              tw-text-blue-600
              tw-px-4
            "
          >
            Adicionar etiqueta
          </button>
        </div>
      </div>
    </div>
    <tag-inputs
      :isFormVisible="isFormVisible"
      :handleTagInputs="handleTagInputs"
      :isEditTag="isEditTag"
      :closeHandleTag="closeHandleTag"
      :currentTag="currentTag"
      :tagInputs="tagInputs"
      :isLoading="isLoading"
      :hasError="hasError"
      v-if="isFormVisible"
    />
    <input
      v-if="eventTags.length === 0"
      type="hidden"
      name="appointment[remove_tags]"
      value="true"
    />
  </div>
</template>

<script>
import TagInputs from "./form/tag-inputs.vue";
import axios from "axios";
import {
  updateTagInEvents,
  removeTagFromEvents,
} from "../helpers/updateEventsInCalendar";

axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-Token": document
    .querySelector("meta[name=csrf-token]")
    .getAttribute("content"),
};

export default {
  components: { TagInputs },
  props: ["savedEventsTags"],
  data() {
    return {
      tooltips: {
        edit: "Editar",
        destroy: "Excluir"
      },
      tags: [],
      isFormVisible: false,
      currentTag: { id: "", name: "", color: "" },
      eventTags: JSON.parse(this.savedEventsTags),
      isEditTag: false,
      isLoading: false,
      tagInputs: {
        hasName: "tw-border-gray-400",
        hasColor: "tw-border-gray-400",
        errorName: false,
        errorColor: false,
      },
      hasError: false,
    };
  },
  methods: {
    async requestsTags() {
      if (this.tags.length > 0) return;
      try {
        this.isLoading = true;
        const response = await axios.get("/tags.json");
        const tags = response.data.data;
        const selectedTags = this.eventTags.map((tag) => tag.id);
        this.tags = tags.map((tag) => ({
          ...tag,
          selected: selectedTags.includes(tag.id),
        }));
        this.isLoading = false;
      } catch (error) {}
    },
    showFormTag() {
      this.isFormVisible = !this.isFormVisible;
    },
    areInputsValid() {
      let isValid = true;
      this.tagInputs.errorName = false;
      this.tagInputs.errorColor = false;

      if (this.currentTag.name === "" || this.currentTag.name.length > 36) {
        this.tagInputs.errorName = true;
        this.tagInputs.hasName = "tw-border-red-500";
        isValid = false;
      }
      if (this.currentTag.color === "") {
        this.tagInputs.errorColor = true;
        this.tagInputs.hasColor = "!tw-border-red-500";
        isValid = false;
      }
      return isValid;
    },
    async handleTagInputs() {
      if (!this.areInputsValid()) {
        return;
      }
      if (this.isEditTag) {
        await this.updateTag(this.currentTag);
      } else {
        this.createNewTag();
      }
      this.closeHandleTag();
    },
    resetInputs() {
      this.currentTag.name = "";
      this.currentTag.color = "";
      this.tagInputs.hasName = "tw-border-gray-400";
      this.tagInputs.hasColor = "tw-border-gray-400";
      this.tagInputs.errorName = false;
      this.tagInputs.errorColor = false;
    },
    closeHandleTag() {
      this.isEditTag = false;
      this.isFormVisible = false;
      this.resetInputs();
    },
    showFormEditTag(tag) {
      this.isEditTag = true;
      this.currentTag = {...tag};
      this.showFormTag();
    },
    async updateTag(currentTag) {
      const tagToEdit = { ...currentTag };
      this.eventTags = this.eventTags.map((tag) =>
        tag.id === tagToEdit.id
          ? {
              ...tag,
              id: tagToEdit.id,
              name: tagToEdit.name,
              color: tagToEdit.color,
            }
          : tag
      );
      this.tags = this.tags.map((tag) =>
        tag.id === tagToEdit.id
          ? {
              ...tag,
              id: tagToEdit.id,
              name: tagToEdit.name,
              color: tagToEdit.color,
            }
          : tag
      );

      try {
        this.isLoading = true;
        await axios.patch(`/tags/${currentTag.id}`, { ...currentTag });
        this.isLoading = false;
        this.resetInputs();
        this.sortTags();
        updateTagInEvents(tagToEdit);
      } catch (error) {
        this.hasError = true;
        console.error(error)
        Bugsnag.notify(error)
      }
    },
    async createNewTag() {
      if (this.currentTag.name.trim()) {
        const newTag = {
          name: this.currentTag.name,
          color: this.currentTag.color,
        };
        try {
          this.isLoading = true;
          const response = await axios.post("/tags", { ...newTag });
          this.tags.push({
            ...response.data.data,
            selected: false,
          });
          this.sortTags();
          this.isLoading = false;
          this.resetInputs();
        } catch (error) {
          this.hasError = true;
        }
      }
    },
    setActiveTag(event, tag) {
      event.stopPropagation();
      const isTagAlreadyActive = this.eventTags.find(
        (findTag) => findTag.id === tag.id
      );
      if (isTagAlreadyActive) return;

      this.eventTags.push({ ...tag });
      this.tags = this.tags.map((listTag) => {
        if (listTag.id === tag.id) {
          return {
            ...listTag,
            selected: true,
          };
        }
        return listTag;
      });
    },
    removeActiveTag(id, event = null) {
      event?.stopPropagation();
      const eventTagsFiltered = this.eventTags.filter((tag) => tag.id !== id);
      this.eventTags = eventTagsFiltered;
      this.tags = this.tags.map((tag) => {
        if (id !== tag.id) return tag;
        return {
          ...tag,
          selected: false,
        };
      });
    },
    async removeTag(currentTag) {
      const { value } = await swal({
        title: "Tem certeza que deseja apagar essa etiqueta?",
        text: "A etiqueta será removida de todos os agendamentos sinalizados com ela.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      });
      if (value === true) {
        try {
          this.isLoading = true;
          await axios.delete(`/tags/${currentTag.id}.json`);
          this.isLoading = false;
          this.removeActiveTag(currentTag.id);
          this.tags = this.tags.filter(tag => tag.id != currentTag.id);
          this.resetInputs();
          removeTagFromEvents(currentTag);
        } catch (error) {
          console.error(error)
          Bugsnag.notify(error)
        }
      }
    },
    sortTags(){
      this.tags = this.tags.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }
  },
};
</script>

